<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :title="preview ? '详情' : model.pkid ? '编辑' : '新建供应商采购'"
      width="1400px"
      class="adaptationModal"
      @close="$reset('form')"
  >
    <el-form
        ref="form"
        v-loading="contentLoading"
        :model="model"
        :rules="ruleValidate"
        class="form"
        label-width="80px">
      <div class="editTitle">采购信息</div>
      <el-row>
        <el-col :span="12">
          <el-form-item label="供应商" prop="supplierName">
            <el-input v-model="model.supplierName" placeholder="请选择供应商" readonly>
              <el-button slot="append" icon="el-icon-search" @click="$refs.supplierSelect.open()"/>
            </el-input>
            <supplier-select ref="supplierSelect" @select="supplierSelect"/>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="editTitle">采购明细</div>
      <el-button :disabled="disabled" type="primary" style="margin-bottom: 8px" @click="$refs.materialSelect.open()">
        添加
      </el-button>
      <Table
          v-loading="tableLoading"
          class="purchaseTable"
          border
          stripe
          :columns="columns"
          :data="model.detailVOS">
        <template slot="deliveryDate" slot-scope="{ row, index }">
          <el-date-picker
              v-model="row.deliveryDate"
              :disabled="disabled"
              style="width: 100%"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="请选择"
              @input="inputHandle(row, index)"
          />
        </template>
        <template slot="qty" slot-scope="{ row, index }">
          <el-input v-model="row.qty" :disabled="disabled" placeholder="请输入" @input="inputHandle(row, index)"/>
        </template>
        <template slot="finalDeliveryDate" slot-scope="{ row, index }">
          <el-date-picker
              v-model="row.finalDeliveryDate"
              :disabled="row.qty === row.sendedQuantity"
              style="width: 100%"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="请选择"
              @input="inputHandle(row, index)"
          />
        </template>
        <template slot="unitPrice" slot-scope="{ row, index }">
          <el-input
              v-if="preview"
              v-model="row.unitPrice"
              placeholder="***"
              disabled
              @input="inputHandle(row, index)"/>
          <el-input
              v-else
              v-model="row.unitPrice"
              placeholder="请输入"
              :disabled="disabled"
              @input="inputHandle(row, index)"/>
        </template>
        <template slot="action" slot-scope="{ index }">
          <el-button :disabled="disabled" type="danger" @click="model.details.splice(index, 1)">删除</el-button>
        </template>
      </Table>
      <div>
        <div class="editTitle" style="margin-top: 15px">订单附件</div>
        <div style="margin-bottom: 8px">
          <upload-file
              ref="upload"
              :disabled="disabled"
              :auth-index="authIndex"
              :show-file-list="false"
              @upload-success="uploadSuccess"/>
        </div>
        <el-table :data="model.attachments" border>
          <el-table-column type="index" align="center" label="#" width="55"/>
          <el-table-column prop="fileName" align="left" label="附件描述" show-overflow-tooltip/>
          <el-table-column label="操作" width="120px" align="center">
            <template slot-scope="scope">
              <el-button v-if="downLoadAuth" type="primary" @click="downLoad(scope.row)">下载</el-button>
              <el-button :disabled="disabled" type="danger" @click="model.attachments.splice(scope.$index, 1)">
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button :loading="submitLoading" :disabled="disabled"  type="primary" @click="submitHandle">确定</el-button>
    </span>
    <supplier-select ref="supplierSelect" @select="supplierSelect"/>
    <material-select ref="materialSelect" @select="materialSelect"/>
  </el-dialog>
</template>

<script>
  import SupplierSelect from "@/views/information/SupplierManage/SupplierSelect";
  import MaterialSelect from "@/views/information/Material/MaterialSelect";
  import UploadFile from "@/components/UploadFile.vue";
  export default {
    components: {
      SupplierSelect,
      MaterialSelect,
      UploadFile,
    },

    data() {
      return {
        downLoadAuth: this.$auth(710),
        disabled: false,
        contentLoading: false,
        dialogVisible: false,
        tableLoading: false,
        submitLoading: false,
        authIndex: 710,
        preview: "",
        model: {
          pkid: 0,
          supplierId: "",
          supplierNo: "",
          supplierName: "",
          detailVOS: [],
          attachments: [],
        },
        columns: [
          {
            title: "物料编号",
            key: "materialNo",
            width: 170,
          },
          {
            title: "物料名称",
            key: "materialName",
            minWidth: 360,
          },
          {
            title: "规格型号",
            key: "specification",
            minWidth: 180,
          },
          {
            title: "要求交期",
            key: "deliveryDate",
            width: 160,
            align: "center",
            slot: "deliveryDate",
          },
          {
            title: "数量",
            key: "qty",
            width: 120,
            align: "center",
            slot: "qty",
          },
          {
            title: "送货单数量",
            width: 105,
            key: "sendedQuantity",
            align: "center",
          },
          {
            title: "最终交期",
            key: "finalDeliveryDate",
            width: 160,
            align: "center",
            slot: "finalDeliveryDate",
          },
          {
            title: "单价",
            key: "unitPrice",
            width: 100,
            slot: "unitPrice",
            align: "center",
          },
          {
            title: "总价",
            width: 80,
            align: "center",
            render: (h, params) => {
              if (this.preview) {
                if (params.row.unitPrice == null || params.row.qty == null) {
                  return h("span", "***");
                } else {
                  return h("span", params.row.unitPrice * params.row.qty);
                }
              } else {
                return h("span", params.row.unitPrice * params.row.qty >= 0 ? params.row.unitPrice * params.row.qty : "");
              }
            },
          },
          {
            title: "操作",
            align: "center",
            width: 80,
            slot: "action",
            fixed: "right",
          },
        ],
        ruleValidate: {
          supplierName: {required: true, message: "请选择供应商", trigger: "change"},
        },
      };
    },

    methods: {
      open(row, mark, preview) {
        this.dialogVisible = true;
        this.disabled = mark;
        this.preview = preview;
        if (row) {
          this.getData(row.pkid);
        }
      },

      supplierSelect(row) {
        this.model.supplierNo = row.no;
        this.model.supplierName = row.name;
        this.model.supplierId = row.pkid;
      },

      getData(pkid) {
        this.contentLoading = true;
        this.$http
          .get("basic", `purchaseOrders/${pkid}`)
          .then((res) => {
            if (res.success) {
              this.model = Object.assign(this.model, res.data);
            }
            this.contentLoading = false;
          })
          .catch(() => {
            this.contentLoading = false;
          });
      },

      materialSelect(row) {
        let item = {
          materialName: row.materialName,
          materialNo: row.materialNO,
          materialId: row.materialID,
        };
        this.model.detailVOS.push(item);
      },

      inputHandle(row, index) {
        this.$set(this.model.detailVOS, index, row);
      },
      // 上传文件
      uploadSuccess(fileList) {
        if (fileList.length) {
          const params = {
            fileName: fileList[0].name,
            filePath: fileList[0].key,
          };
          this.model.attachments.push(params);
        }
      },

      // 附件下载
      downLoad(row) {
        this.$http.get("basic", `files/getDownloadUrl?key=${encodeURIComponent(row.filePath)}`).then((res) => {
          if (res.success) {
            window.open(res.data);
          }
        });
      },

      submitHandle() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .save("basic", "purchaseOrders", this.model)
              .then((resp) => {
                this.submitLoading = false;
                if (resp.success) {
                  if (this.model.pkid) {
                    this.$emit("save-success");
                    this.$message.success("编辑成功");
                  } else {
                    this.$emit("save-success");
                    this.$message.success("添加成功");
                  }
                  this.dialogVisible = false;
                }
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
.purchaseTable .el-input__inner {
  text-align: center;
}
</style>
